import { FC } from "react";
import { Button, Card, Typography, useTheme } from "@mui/material";
import { Hexagon } from "../../../../components/ui";

type Props = {
  planName: string;
  renewsAt: string;
  isFree: boolean;
  onManage: () => void;
};

/** Card "Seu plano" (gradiente espresso) do perfil. */
const ProfilePlanCard: FC<Props> = ({ planName, renewsAt, isFree, onManage }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        borderRadius: "18px",
        p: "24px",
        background: theme.palette.brand.heroCard,
        border: `1px solid ${theme.palette.brand.heroCardBorder || "transparent"}`,
        color: theme.palette.common.white,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Hexagon size={64} fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.12)" strokeWidth={2} sx={{ position: "absolute", top: -12, right: -12 }} />

      <Typography sx={{ fontSize: "0.6875rem", fontWeight: 700, letterSpacing: "0.1em", color: "rgba(255,255,255,0.6)", textTransform: "uppercase", mb: 0.75 }}>
        Seu Plano
      </Typography>
      <Typography sx={{ fontFamily: theme.typography.fontFamilyDisplay, fontSize: "1.5rem", color: theme.palette.common.white, mb: renewsAt ? 0.5 : 2 }}>
        {planName}
      </Typography>
      {renewsAt && (
        <Typography sx={{ fontSize: "0.8125rem", color: "rgba(255,255,255,0.7)", mb: 2 }}>Renova em {renewsAt}</Typography>
      )}

      <Button
        variant="outlined"
        size="small"
        onClick={onManage}
        sx={{
          borderColor: "rgba(255,255,255,0.4)",
          color: theme.palette.common.white,
          borderRadius: "8px",
          textTransform: "none",
          fontSize: "0.8125rem",
          "&:hover": { borderColor: "rgba(255,255,255,0.7)", bgcolor: "rgba(255,255,255,0.08)" },
        }}
      >
        {isFree ? "Conhecer planos" : "Gerenciar plano"}
      </Button>
    </Card>
  );
};

export default ProfilePlanCard;
